<template>
  <div class="flex-wrap flex-line align-stretch" style="width:100%;">
    <div style="width:200px;flex-shrink:0" v-if="sessions.length > 0">
      <template v-for="session in sessions">
        <div :key="session.user_id" class="flex-wrap flex-between">
          <div class="flex-wrap flex-line">
          <BaseAvatar :uid="session.avatar" size="40" shape="square">{{session.name}}</BaseAvatar>
          <div>
          <div>{{session.name}}</div>
          <div v-if="session.message">{{session.message}}</div>
          </div>
          </div>
          <div>
          </div>
        </div>
      </template>
    </div>
    <div style="position:relative;flex-grow:1;border-left:1px solid var(--border);width:100%;">
      <BaseEmpty msg="请前往通讯录发起对话" v-if="!selected || !selected.user_id" />
      <div v-else style="height:100%;position:relative;">
        <div style="height:calc(100% - 45px)">
          <template v-if="selected.messages">
            <template v-for="m in messages">
              <div :key="m.id">
                {{m.message}}
              </div>
            </template>
          </template>

        </div>
        <div class="flex-wrap flex-line" style="height:45px;border-top:1px solid var(--border);padding:5px 0;">
          <Input style="height:100%;width:100%;margin-left:5px;" v-model="message" placeholder="请输入内容" />
          <BaseIcon icon="md-send" size="25" style="padding:5px;color:var(--primary)" @click="sendMessage" />
          <BaseIcon icon="md-add" size="25" style="padding:5px;padding-left:0;" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      sessions: [],
      search_text: '',
      selected: {},
      message: '',
    };
  },
  activated() {
    setTimeout(()=>{
      this.getData();
    }, 500);
  },
  methods: {
    getChatData(session_id) {
      this.$api.get('/chat-sessions/'+session_id).then((res)=>{
        const sessions = res.data.data;
        sessions.forEach((v)=>{
          const users = this.$store.getters['session/users'];
          const user = users.find((u)=>u.id == v.user_id);
          v.avatar = user.avatar;
          v.name = user.name;
        });
        this.sessions = sessions;
      });
    },
    getData() {
      this.$api.get('/chat-sessions').then((res)=>{
        const sessions = res.data.data;
        sessions.forEach((v)=>{
          const users = this.$store.getters['session/users'];
          const user = users.find((u)=>u.id == v.user_id);
          v.avatar = user.avatar;
          v.name = user.name;
        });
        this.sessions = sessions;
      });
    },
    sendMessage() {
      const message = {message: this.message};
      this.$api.post('/chat-sessions', {to: this.selected.user_id, message: this.message}).then((res)=>{
        Object.assign(message, res.data.data);
        this.session.messages.splice(0, 0, message);
        this.message = '';
      });
    },
    createSession(user_id) {
      const users = this.$store.getters['session/users'];
      const user = users.find((u)=>u.id == user_id);

      let session = this.sessions.find((v)=>v.user_id == user_id);
      if (!session) {
        session = {user_id, name: user.name, avatar: user.avatar};
        this.sessions.splice(0, 0, session);
      }
      this.selected = session;
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
